<template>
  <v-container>
    <Title title="Unit Details"></Title>

    <v-row>
      <v-col lg="12" class="pb-2">
        <h2 style="display: inline-block">Pending Unit Request</h2>
        <v-btn
          tile
          v-if="!this.$route.query.id"
          style="float: right;"
          color="primary"
          dark
          class="mb-2 ml-3"
          @click="onFinalizeRequest('approved')"
        >Approve</v-btn>
        <v-btn
          tile
          style="float: right;"
          color="error"
          dark
          class="mb-2"
          @click="onFinalizeRequest('rejected')"
        >Reject</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col lg="12">
        <h3>Centre Details</h3>
        <CentreSummary class="mb-12" />
        <h3>Unit Details</h3>
        <UnitSummary class="mb-12" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CentreSummary from "../components/CentreSummary";
import UnitSummary from "../components/UnitSummary";
import Title from "../components/Title";

export default {
  mounted: function () {},
  components: {
    CentreSummary,
    UnitSummary,
    Title,
  },
  data: function () {
    return {};
  },
  methods: {
    onFinalizeRequest: function (status) {
      if (status.toLowerCase() == "approved") {
        const confirmApprove = window.confirm(`Is the invoice risen?`);
        if (!confirmApprove) {
          return;
        }
      }

      const data = {
        centreId: this.$route.query.centreId,
        unitId: this.$route.query.unitId,
        status: status,
      };

      fetch(`${process.env.VUE_APP_ROOT_API}/centres/pending`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then((data) => {
          this.$router.push({
            name: "Dashboard",
            params: { message: data.message },
          });
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>

<style scoped>
</style>

